/* Copyright (c) 2021 MOCA Systems, Inc.  All rights reserved. */

import { FancyAction } from 'src/app/common/fancy-firebase/base/FancyAction';
import { FancyActionableFirebase } from 'src/app/common/fancy-firebase/generics/FancyActionableFirebase';
import { CustomFieldDropDownDefinitionList } from 'src/app/common/fancy-firebase/lists/CustomFieldDropDownDefinitionList';
import { CustomFieldDropDownDefinition } from '../models/CustomFieldDropDownDefinition';

export class CustomFieldDropDownDefinitions extends FancyActionableFirebase<
	CustomFieldDropDownDefinition,
	FancyAction,
	CustomFieldDropDownDefinitionList
> {
	constructor(public data: CustomFieldDropDownDefinitionList) {
		super(data);
	}
}
